import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import { BASE_API_URL } from 'api/client';
import { LoginPayload } from 'api/models/payload';
import { LoginResponse } from 'api/models/response';

export function login(
    userData: LoginPayload,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<LoginResponse>> {
    return axios.post<LoginResponse>(`${BASE_API_URL}/login`, userData, customConfig);
}
